import React from "react";

const NotAuthorized = () => {
  return (
    <div className="not-authorized">
      <div className="not-authorized-icon">
        <i className="fa-solid fa-lock"></i>
      </div>
      <h1 className="not-authorized-title">Access restricted</h1>
      <p className="not-authorized-subtitle">
        You don't have permission to view this page. Contact an admin if you
        think this is a mistake.
      </p>
    </div>
  );
};

export default NotAuthorized;
